import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class AppConfigurationService {
  public configuration = {
    applicationVersion: 'Unknown Version',
    applicationInactivityTimeoutMinutes: 10,
    title: 'Datawarehouse',
    titleDescription: '',
    landingPageMessage: '',
    maxFileSize: 20,
    logo: null,
    deletionSequenceEnabled: false,
    deletionSequence: "ServiceEvent, TreatmentEpisode, WaitingList, AcuteCare, Subcontract, Client, Provider",
    customerDisplayName: "",
    baseCodeSystems: "",
    hasSubmittingEntityIdentifier: false,
    jurisdictionalDomain: 'bird',
    defaultHome: 'submission',
    securityServer: {
      disabled: false,
      baseEndpoint: '',
      oidcEndpoint: '',
      browserUserAccountSessionIframeSrcStem: '',
      browserUserAccountSessionKeepAliveIntervalMilliseconds: 1000,
      clientId: '',
      isDelegatingAccountManagementToOtherSystem: false,
      isUsingDefaultIssuerFormat: false,
      scope: 'openid profile email'
    },
    isDelegatingSubmittingEntityManagementToOtherSystem: false,
    isHybridAccountManagement: false,
    isUsingVms: false,
    allUserAccountActionsAreDisplayed: false
  }

  constructor() {
    var appConfig = (window as any).birdApplicationConfig;
    if (appConfig) {
      this.configuration = { ...this.configuration, ...appConfig };
    }

    if (environment) {
      this.configuration = { ...this.configuration, ...(environment as any) };
    }
  }

  public updateConfiguration(config): void {
    this.configuration = { ...this.configuration, ...config };
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/AppConfigurationService.ts